export const AEM_PATH_PREFIX = '/content/waitrosegroceriescms/en';

// URLs not served by Content Renderer
export const EXTERNAL_ROUTES = {
  homepage: '/',
};
